import React, { createContext, useContext, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("tozan_token"));
  const [username, setUsername] = useState(() => localStorage.getItem("tozan_user"));

  const login = async (u, p) => {
    const res = await api.post("/auth/login", { username: u, password: p });
    localStorage.setItem("tozan_token", res.data.access_token);
    localStorage.setItem("tozan_user", res.data.username);
    setToken(res.data.access_token);
    setUsername(res.data.username);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("tozan_token");
    localStorage.removeItem("tozan_user");
    setToken(null);
    setUsername(null);
  };

  return (
    <AuthContext.Provider value={{ token, username, login, logout, isAuthed: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
